<template>
    <div id="pagination" v-if="!isloading && totRecords > 0">
        <div>
            <b>Showing:</b>
            [<span v-for="p in page" v-bind:key="p" v-on:click="handlePerPage(p)"
                    :class="perPageClass(p)">{{p}}</span>]
            results {{startRecord}} to {{parseInt(currentPage) === parseInt(lastPage) ? totRecords : lastRecord}}
            of {{totRecords}}
            records
        </div>
        <div v-on:click="paginate(0)" :class="isCurrentPageClass">[First]</div>
        <div v-on:click="paginate(-1)" :class="isCurrentPageClass">[Prev {{perpage}}]</div>
        <div>
            [<span v-for="(v, i) in getPages" v-bind:key="i" v-on:click="getDataByPage(v)"
                    v-bind:class="activeText(v)">{{v}}</span>]
        </div>
        <div v-on:click="paginate(+1)" :class="getLastPageClass">
            [Next {{perpage}}]
        </div>
        <div v-on:click="last()" :class="getLastPageClass">[Last]</div>
    </div>
</template>

<script>
export default {
    name: 'Pagination',
    data: () => ({
        page: [10, 20, 30, 40, 50],
    }),
    props: [
        'isloading',
        'startRecord',
        'currentPage',
        'lastPage',
        'lastRecord',
        'totRecords',
        'isCurrentPageClass',
        'perpage',
        'getLastPageClass',
        'totPage',
        'getPages'
    ],
    methods: {
        handlePerPage: function (p) {
            this.$emit('handlePerPage', p)
        },
        perPageClass: function (p) {
            return this.perpage === p ? "" : "notactivespan"
        },
        activeText: function (n) {
            return parseInt(n) === parseInt(this.currentPage) ? '' : 'notactivespan'
        },
        getDataByPage: function (page) {
            this.$emit('getDataByPage', page)
        },
        paginate: function (n) {
            this.$emit('paginate', n)
        },
        last: function () {
            this.$emit('last', '')
        },
    }
}
</script>

<style lang="sass" scoped>
    @import "./../assets/sass/pagination.sass"
</style>
